module.exports = __webpack_public_path__ + "static/media/footer.d331087c.png";